import { phoneAuthAdminQueryKeys as e } from "./phoneAuthAdminQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminPhoneAuthApi as n } from "@maat/api-main";
//#region src/phoneAuth/admin/usePhoneAuthStatsQuery.ts
var r = (r) => t({
	queryKey: e.stats(r),
	queryFn: () => n.stats(r)
});
//#endregion
export { r as usePhoneAuthStatsQuery };
